module.exports = __webpack_public_path__ + "static/media/moderator-correct-answer.055a921c.gif";